export const getInitialFormData = (practitioner) => ({
  avatar: practitioner?.avatar || null,
  bio: practitioner?.bio || "",
  specialities: practitioner?.specialities ?? [],
  experience: practitioner?.experience ?? [],
  education: practitioner?.education ?? [],
  certifications: practitioner?.certifications ?? [],
  memberships: practitioner?.memberships ?? [],
  languages: practitioner?.languages ?? [],
  hourlyRate: practitioner?.hourlyRate || 0,
  instituteCertifications: practitioner?.instituteCertifications ?? [],
  website: practitioner?.website || "",
  linkedIn: practitioner?.linkedIn || "",
  twitter: practitioner?.twitter || "",
  fb: practitioner?.fb || "",
  instagram: practitioner?.instagram || "",
  streetAddress: practitioner?.streetAddress || "",
  phone: practitioner?.phone || "",
  desc: practitioner?.desc || "",
  field1: practitioner?.field1 || "",
  field2: practitioner?.field2 || "",
  coverPicture: practitioner?.coverPicture || "",
  city: practitioner?.city || "",
  state: practitioner?.state || "",
  postalCode: practitioner?.postalCode || "",
  country: practitioner?.country || "United States",
});

const appendPipe = (value) =>
  value.endsWith(" |") ? value : value + " |";

export const sanitizeFormDataForSave = (formData, multiValueFields) => {
  const sanitized = { ...formData };
  multiValueFields.forEach((field) => {
    if (Array.isArray(sanitized[field])) {
      sanitized[field] = sanitized[field].map(appendPipe);
    }
  });
  return sanitized;
};
